var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative w-full h-full"},[(_vm.loading)?_c('div',{staticClass:"skeleton-loader"}):_vm._e(),_c('img',{staticClass:"image",class:{ 'hidden': _vm.loading, 'fade-in': !_vm.loading },attrs:{"src":_vm.src,"alt":_vm.alt},on:{"load":_vm.onLoad,"error":_vm.onError}})])
}
var staticRenderFns = []

export { render, staticRenderFns }